module.exports = __webpack_public_path__ + "static/media/photo.a280c108.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/markers/photo.svg
// module id = 203
// module chunks = 0